export default __webpack_public_path__ + "static/media/ArrowUpIcon.a0d626c1.svg";